import { ConfigurationType } from 'civil-status/constants/configuration-type';
import { SectionVM, TrascrizioneNascita } from 'civil-status/view-models/step-form';

export const transformerTrascrizioneNascita = (
  dataSection?: SectionVM,
  dataTranscriptionBirth?: SectionVM,
  dataDatiGenerali?: SectionVM,
  idEvento?: number
): TrascrizioneNascita | undefined => {
  if (!(dataSection || dataDatiGenerali || dataTranscriptionBirth)) {
    return undefined;
  }

  return {
    key: idEvento
      ? {
          idEvento,
        }
      : undefined,
    dataComunicazione: dataSection?.dateTranscription
      ? dataSection?.dateTranscription?.toFormat('yyyy-MM-dd')
      : undefined,
    dataProvvedCambioCognome: dataSection?.dateChangeSurname
      ? dataSection?.dateChangeSurname?.toFormat('yyyy-MM-dd')
      : undefined,
    vecchioCognomeGenitore: dataSection?.oldSurname || undefined,
    cambioCognome: dataSection?.typeMutation || undefined,
    genitoreMutazioneCognome: dataSection?.parentChangedSurname || undefined,
    provvedCambioCognome: dataSection?.measureExchangeSurname || undefined,
    trascrizione: dataSection?.templateTranscriptionText || undefined,
    dichiarazione:
      dataSection?.configuration === ConfigurationType.DSNAS03 ||
      dataSection?.configuration === ConfigurationType.DSNAS04
        ? 2
        : dataSection?.typeRequest
        ? Number.parseInt(dataSection?.typeRequest, 10)
        : undefined,
    richiedenteNascita: dataSection?.applicant?.id?.toString() || undefined,
    descrizioneRichiedenteNascita: dataSection?.applicant?.value || undefined,
    luogoNascita: dataSection?.typeBirthPlace || undefined,
    specificaLuogoNascita: dataSection?.descriptionBirthPlace || undefined,
    sceltaCognome: dataSection?.changeSurname || dataDatiGenerali?.changeSurname || undefined,
    nuovoCognome: dataSection?.newSurname || dataDatiGenerali?.newSurname || undefined,
    nuovoNome: dataSection?.newName || undefined,
    cognomeAggiunto: dataSection?.surnameAdded || undefined,
    nomeAggiunto: dataSection?.nameAdded || undefined,
    riconoscimentoNascita:
      dataSection?.sentenceRecognition ||
      dataDatiGenerali?.sentenceRecognition ||
      dataSection?.parentRecognition ||
      undefined,
    flagRiconPaternoConSentenza:
      dataDatiGenerali || dataSection?.configuration === ConfigurationType.DSNAS01
        ? dataDatiGenerali?.isPaternitySentence || dataSection?.isPaternitySentence
          ? '1'
          : '0'
        : undefined,
    flagFiglioDiIgnoti: dataTranscriptionBirth
      ? dataTranscriptionBirth?.isSonUnknownParents
        ? '1'
        : '0'
      : undefined,
    numeroIntestatari: dataSection?.numberHolders
      ? Number.parseInt(dataSection?.numberHolders, 10)
      : undefined,
    numeroFigli: dataSection?.numberChildren
      ? Number.parseInt(dataSection?.numberChildren, 10)
      : undefined,
    codiceSezione: dataSection?.codeSection || undefined,
    configurazione: dataSection?.configuration || undefined,
    tipoSezione: dataSection?.typePersistence || undefined,
  };
};
